module.exports = __webpack_public_path__ + "static/media/america-necaxa.9f0fb397.mp4";